import { FormControl, Grid, InputLabel, MenuItem, Select, Box, FormControlLabel, Checkbox } from '@mui/material';
import React, { FC, useState, useEffect } from 'react';
import { SCUIAutoCompleteInput, SCUIButton, SCUILoadingLinear } from '../../../../../atomic/atoms';
import { SCUITextFieldWithButton } from '../../../../../atomic/molecules';
import { ReturnCommand } from '../../../../../services/command';
import { ReturnQuery } from '../../../../../services/query';
import { SimulateReturnProducts } from '../../CreateReturn.helper';
import { SCUIReturnProductTable } from '../SCUIReturnProductTable/SCUIReturnProductTable';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { CRAS2 } from './createReturnActiveStep2.classes';

export const CreateReturnActiveStep2: FC<{
    setSelectedSellerID: any;
    sellerName: any;
    isSellerStore: any;
    selectedShipping: any;
    orderID: any;
    customerID: any;
    onClickStepNext: any;
    setSimulateReturnResponse: any;
    setSimulateReturnRequest: any;
    selectedProductCount: any;
    setSelectedProductCount: any;
    showCMIY: boolean;
    cmiyCheckboxChanged: (checkedCMIY: any) => void;
}> = ({
    setSelectedSellerID,
    sellerName,
    isSellerStore,
    selectedShipping,
    orderID,
    customerID,
    onClickStepNext,
    setSimulateReturnResponse,
    setSimulateReturnRequest,
    selectedProductCount,
    setSelectedProductCount,
    showCMIY,
    cmiyCheckboxChanged,
}) => {
    const [searchedBarcode, setSearchedBarcode] = useState<any>('');
    const [shippingContent, setShippingContent] = React.useState<any>(selectedShipping);
    const [selectedProducts, setSelectedProducts] = React.useState<any>([]);
    const [returnReasonForAllUpdateForSelect, setReturnReasonForAllUpdateForSelect] = useState(4);
    const [returnReasonForAllUpdate, setReturnReasonForAllUpdate] = useState(0);
    const [loading, setLoading] = React.useState(false);
    const [returnReason, setReturnReason] = useState<any>();
    const { t } = useTranslation();
    const [checkedCMIY, setCheckedCMIY] = React.useState(false);
    const handleChange = (event: any) => {
        setCheckedCMIY(event.target.checked);
        cmiyCheckboxChanged(event.target.checked);
    };
    const ReasonLostPackageId = 13;

    const getIsLostPackageFromShipping = () => {
        if (selectedShipping && selectedShipping.length > 0) {
            const isLostPackage = selectedShipping[0]?.isLostPackage;
            return isLostPackage === true;
        }
        return false;
    };

    const fetchReturnReason = async () => {
        try {
            const isLostPackage = getIsLostPackageFromShipping();

            const params: any = {
                isMarketPlaceReturn: isSellerStore,
                shippingHasLostPackage: isLostPackage,
            };

            if (checkedCMIY) {
                params.checkedCMIY = checkedCMIY;
            }

            const res = await ReturnQuery.GetReturnReason(params);
            setReturnReason(res.data);
        } catch (error) {
            console.error('Hata: ', error);
        }
    };

    useEffect(() => {
        if (selectedShipping && selectedShipping.length > 0) {
            fetchReturnReason();
        }
    }, [selectedShipping, checkedCMIY, isSellerStore]);
    const filtrele = (): void => {
        let productFromService = shippingContent.filter(
            (element: any) =>
                element.barcode === Number(searchedBarcode.trim()) ||
                element.barcodeList?.includes(Number(searchedBarcode.trim()))
        );

        const scannedBarcode = Number(searchedBarcode.trim());

        if (productFromService.length === 0) {
            Swal.fire({
                icon: 'error',
                title: 'Böyle bir ürün bulunmamaktadır',
                showConfirmButton: false,
                timer: 1000,
            });
            setSearchedBarcode('');
            return;
        }

        const productInfo = productFromService[0];
        const existingIndex = selectedProducts.findIndex((item: any) => item.OrderItemId === productInfo.orderItemId);
        
        if (existingIndex < 0) {
            Swal.fire({
                icon: 'success',
                title: t('refund.productScannedSuccessfully'),
                showConfirmButton: false,
                timer: 1000,
            });
            let product: SimulateReturnProducts = {
                LineNumber: 0,
                OrderItemId: productInfo.orderItemId,
                OrderLineNumber: 0,
                ProductId: productInfo.productId,
                Quantity: 1,
                ReturnItemId: 0,
                ReturnReasonId: returnReasonForAllUpdateForSelect,
                ShippingListId: productInfo.shippingListId,
                WarehouseId: 0,
                Barcode: scannedBarcode,
            };
            setSelectedProducts([...selectedProducts, product]);
            setShippingContent((prevItems: any) =>
                prevItems.map((item: any) =>
                    item.orderItemId === productInfo.orderItemId
                        ? {
                              ...item,
                              quantitySelectForBarcode: Number(1),
                              reasonSelectForBarcode: returnReasonForAllUpdateForSelect,
                          }
                        : item
                )
            );
        } else {
            Swal.fire({
                icon: 'success',
                title: t('refund.productScannedSuccessfully'),
                showConfirmButton: false,
                timer: 1000,
            });
            setShippingContent((prevItems: any) =>
                prevItems.map((item: any) =>
                    item.orderItemId === productInfo.orderItemId
                        ? {
                              ...item,
                              reasonSelectForBarcode: returnReasonForAllUpdateForSelect,
                              quantitySelectForBarcode:
                                  item.quantitySelectForBarcode < productInfo.quantity
                                      ? Number(item.quantitySelectForBarcode + 1)
                                      : item.quantitySelectForBarcode,
                          }
                        : item
                )
            );
            setSelectedProducts((prevItems: any) =>
                prevItems.map((item: any) =>
                    item.OrderItemId === productInfo.orderItemId
                        ? {
                              ...item,
                              Quantity: item.Quantity < productInfo.quantity ? item.Quantity + 1 : item.Quantity,
                              ReturnReasonId: returnReasonForAllUpdateForSelect,
                              Barcode: scannedBarcode,
                          }
                        : item
                )
            );
        }
        setSearchedBarcode('');
    };
    const simulateReturn = async () => {
        setLoading(true);

        let isLostPackage = false;
        if (returnReason.length == 1 && returnReason[0].returnReasonId == ReasonLostPackageId) {
            isLostPackage = true;
        }
        let params: any = {};
        params.return = {};
        params.items = selectedProducts;
        params.customerId = customerID;
        params.orderId = orderID;
        params.isMarketPlaceReturn = isSellerStore;
        params.isLostPackage = isLostPackage;
        setSimulateReturnRequest(params);
        ReturnCommand.SimulateReturnRest(params)
            .then((res: any) => {
                if (res) {
                    setSimulateReturnResponse(res);
                    onClickStepNext();
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onChange = (event: any, data: any, type: string) => {
        let reason = 0;

        if (type === 'Reason') {
            reason = event.target.value;
        } else if (type === 'Quantity' && event.target.value === 0) {
            reason = 0;
        }
        let product: SimulateReturnProducts = {
            LineNumber: 0,
            OrderItemId: data.orderItemId,
            OrderLineNumber: 0,
            ProductId: data.productId,
            Quantity: type === 'Quantity' ? event.target.value : 0,
            ReturnItemId: 0,
            ReturnReasonId: reason,
            ShippingListId: data.shippingListId,
            WarehouseId: 0,
            Barcode: data.barcode,
        };
        const existingIndex = selectedProducts.findIndex((item: any) => item.OrderItemId === data.orderItemId);
        if (selectedProducts.length === 0) setSelectedProducts([...selectedProducts, product]);
        if (existingIndex !== -1) {
            if (event.target.value === 0) {
                setShippingContent((prevItems: any) =>
                    prevItems.map((item: any) =>
                        item.barcode === Number(data.barcode) && item.orderItemId === data.orderItemId
                            ? {
                                  ...item,
                                  reasonSelectForBarcode: type === 'Quantity' ? 0 : data.reasonSelectForBarcode,
                              }
                            : item
                    )
                );

                setSelectedProducts(selectedProducts.filter((item: any) => item.OrderItemId !== data.orderItemId));
            } else {
                setSelectedProducts(
                    selectedProducts.map((item: any) => {
                        if (item.OrderItemId === data.orderItemId) {
                            if (type === 'Quantity') {
                                return { ...item, Quantity: event.target.value };
                            } else {
                                return { ...item, ReturnReasonId: event.target.value };
                            }
                        }
                        return item;
                    })
                );
            }
        } else {
            if (event.target.value !== 0) {
                setSelectedProducts([...selectedProducts, product]);
            }
        }
        if (type === 'Quantity') {
            setShippingContent((prevItems: any) =>
                prevItems.map((item: any) =>
                    item.barcode === Number(data.barcode) && item.orderItemId === data.orderItemId
                        ? {
                              ...item,
                              quantitySelectForBarcode: event.target.value,
                          }
                        : item
                )
            );
        }
    };
    useEffect(() => {
        let count = 0;
        if (selectedProducts && selectedProducts.length) {
            selectedProducts.forEach((item: any) => {
                count += item.Quantity;
            });
        }
        setSelectedProductCount(count);
    }, [selectedProducts]);

    useEffect(() => {
        if (returnReason && returnReason.length === 1) {
            setReturnReasonForAllUpdateForSelect(returnReason[0].returnReasonId);
        }
    }, [returnReason]);

    const allProductUpdate = () => {
        let allProduct = shippingContent.map((item: any) => {
            return {
                LineNumber: 0,
                OrderItemId: item.orderItemId,
                OrderLineNumber: 0,
                ProductId: item.productId,
                Quantity: item.quantity,
                ReturnItemId: 0,
                ReturnReasonId: returnReasonForAllUpdateForSelect,
                ShippingListId: item.shippingListId,
                WarehouseId: 0,
                Barcode: item.barcode,
            };
        });
        setSelectedProducts(allProduct);
        setReturnReasonForAllUpdate(returnReasonForAllUpdateForSelect);

        setShippingContent(
            shippingContent.map((item: any) => ({
                ...item,
                quantitySelectForBarcode: item.quantity,
                reasonSelectForBarcode: returnReasonForAllUpdateForSelect,
            }))
        );
    };

    useEffect(() => {
        setSimulateReturnResponse(null);
    }, []);

    return (
        <Grid className={CRAS2.root} container sx={{ paddingBottom: '2rem', paddingTop: '1rem' }} spacing={5}>
            <div className={CRAS2.loadingSection}>
                <SCUILoadingLinear display={loading} />
            </div>
            <Grid
                className={CRAS2.barcodeCol}
                size={{
                    xl: 3,
                    lg: 4,
                    md: 12,
                    xs: 12,
                }}
            >
                <SCUITextFieldWithButton
                    placeholder={t('searchService.barcode')}
                    width={300}
                    paperClassName={CRAS2.barcodePaper}
                    inputClassName={CRAS2.barcodeInput}
                    buttonClassName={CRAS2.barcodeButton}
                    onChange={(event: any) => {
                        setSearchedBarcode(event.target.value);
                    }}
                    autoFocus={true}
                    value={searchedBarcode}
                    onClick={() => filtrele()}
                    onKeyPress={(e: any) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            filtrele();
                        }
                    }}
                />
            </Grid>
            <Grid
                className={CRAS2.quickActionCol}
                size={{
                    xl: 1,
                    lg: 1,
                    md: 0,
                    xs: 12,
                }}
            >
                <p className={[CRAS2.quickActionText, 'subheadtxt'].join(' ')}>{t('general.quickAction')}</p>
            </Grid>
            <Grid
                className={CRAS2.reasonSelectCol}
                size={{
                    xl: 3,
                    lg: 4,
                    md: 6,
                    xs: 12,
                }}
            >
                <FormControl className={CRAS2.reasonFormControl} fullWidth>
                    <InputLabel id="demo-simple-select-label">{t('general.returnReason')}</InputLabel>
                    <Select
                        className={CRAS2.reasonSelect}
                        variant="outlined"
                        style={{ width: 300 }}
                        label={'iade nedeni'}
                        value={returnReasonForAllUpdateForSelect}
                        onChange={(event: any) => setReturnReasonForAllUpdateForSelect(event.target.value)}
                    >
                        {returnReason &&
                            returnReason.map((item: any, index: number) => (
                                <MenuItem
                                    className={CRAS2.reasonSelectItem}
                                    key={index}
                                    id={item.returnReasonId}
                                    value={item.returnReasonId}
                                >
                                    {item.reasonName}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
            </Grid>
            {sellerName && (
                <Grid
                    className={CRAS2.sellerAutocompleteCol}
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 2,
                        xl: 2,
                    }}
                >
                    <div className={CRAS2.sellerAutocompleteWrap}>
                        <SCUIAutoCompleteInput
                            list={sellerName}
                            onChange={(_: any, newValue: any) => {
                                setSelectedSellerID(newValue.sellerId);
                            }}
                            multiple={false}
                            txtPlaceHolder={'Satıcı Adı'}
                            searchValue="storeName"
                        />
                    </div>
                </Grid>
            )}
            <Grid
                className={CRAS2.applyAllCol}
                size={{
                    xl: 2,
                    lg: 2,
                    md: 4,
                    xs: 12,
                }}
            >
                <SCUIButton
                    className={CRAS2.applyAllButton}
                    text={t('general.applyToAll')}
                    type="secondary"
                    sizeType="fixed"
                    size={'m'}
                    onClick={allProductUpdate}
                />
            </Grid>
            {showCMIY && (
                <Grid
                    className={CRAS2.exceptionRow}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <FormControlLabel
                        className={CRAS2.exceptionControl}
                        style={{ color: checkedCMIY ? 'red' : '' }}
                        control={
                            <Checkbox
                                className={CRAS2.exceptionCheckbox}
                                checked={checkedCMIY}
                                onChange={handleChange}
                                name="checkedB"
                                color="primary"
                                style={{ color: checkedCMIY ? 'red' : '' }}
                            />
                        }
                        label={t('return.exceptionReturn')}
                    />
                </Grid>
            )}
            <Grid
                className={CRAS2.productsSection}
                sx={{ marginTop: 3 }}
                size={{
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                {shippingContent &&
                    shippingContent.map((product: any, index: number) => (
                        <div className={CRAS2.productRowWrap} key={index}>
                            <SCUIReturnProductTable
                                data={product}
                                type={'action'}
                                onChange={onChange}
                                returnReason={returnReason}
                                returnReasonForAllUpdate={returnReasonForAllUpdate}
                            />
                        </div>
                    ))}
            </Grid>
            <Grid
                className={CRAS2.totalsRow}
                justifyContent="flex-end"
                sx={{ paddingRight: '5rem' }}
                size={{
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Box className={CRAS2.totalsWrap} display="flex" justifyContent="flex-end">
                    <p className={CRAS2.totalsText}>
                        <strong>
                            {t('general.totalProductQuantity')} : {selectedProductCount}
                        </strong>{' '}
                    </p>
                </Box>
            </Grid>
            {selectedProducts.length > 0 &&
                !selectedProducts.some((product: any) => product.Quantity === 0 || product.ReturnReasonId === 0) && (
                    <Grid
                        className={CRAS2.continueRow}
                        justifyContent="flex-end"
                        sx={{ paddingRight: '5rem' }}
                        size={{
                            xs: 12,
                            md: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Box display="flex" justifyContent="flex-end">
                            <SCUIButton
                                className={CRAS2.continueButton}
                                text={t('general.continue')}
                                type="primary"
                                sizeType="fixed"
                                disabled={loading}
                                onClick={() => simulateReturn()}
                                size={'m'}
                            />
                        </Box>
                    </Grid>
                )}
        </Grid>
    );
};
